export default __webpack_public_path__ + "static/media/cast12.4199eb99.png";